// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"P9-z"};